App.vue.setComponent(
  require('@components/Cabinet/Repair/CheckingRepairStatus/CheckingRepairStatus.vue').default
);
